export enum Category {
  General = 'general',
  Dashboard = 'dashboard',
  SalesOrders = 'sales_orders',
  NetworkOrders = 'network_orders',
  PurchaseOrders = 'purchase_orders',
  Inventory = 'inventory',
  UserProfile = 'user_profile',
}
